export default __webpack_public_path__ + "static/media/cancelled.8d22da96.svg";